<template>
  <div id="content-wrapper">
    <b-tabs content-class="mt-3">
      <b-tab
        title="Vùng"
        v-if="!(disabledItem && this.$route.params.id === 'tao-moi')"
        :active="activeTab === `#${TINH_THANH_TAB.VUNG}`"
        @click="
          changeCurrentTab(TINH_THANH_TAB.VUNG, GIA_TRI_TINH_THANH_TAB.VUNG)
        "
      >
        <div
          class="box box-form"
          v-if="!activeTab || activeTab === `#${TINH_THANH_TAB.VUNG}`"
        >
          <DanhSachChung isVung />
        </div>
      </b-tab>
      <b-tab
        title="Tỉnh/ Thành phố"
        v-if="!(disabledItem && this.$route.params.id === 'tao-moi')"
        :active="activeTab === `#${TINH_THANH_TAB.TINH_THANH}`"
        @click="
          changeCurrentTab(
            TINH_THANH_TAB.TINH_THANH,
            GIA_TRI_TINH_THANH_TAB.TINH_THANH
          )
        "
      >
        <div
          class="box box-form"
          v-if="activeTab === `#${TINH_THANH_TAB.TINH_THANH}`"
        >
          <DanhSachChung isTinhThanh />
        </div>
      </b-tab>
      <b-tab
        title="Quận/ Huyện"
        :active="activeTab === `#${TINH_THANH_TAB.QUAN_HUYEN}`"
        v-if="!(disabledItem && this.$route.params.id === 'tao-moi')"
        @click="
          changeCurrentTab(
            TINH_THANH_TAB.QUAN_HUYEN,
            GIA_TRI_TINH_THANH_TAB.QUAN_HUYEN
          )
        "
      >
        <div
          class="box box-form"
          v-if="activeTab === `#${TINH_THANH_TAB.QUAN_HUYEN}`"
        >
          <DanhSachChung isQuanHuyen />
        </div>
      </b-tab>
      <b-tab
        title="Phường/ Xã"
        :active="activeTab === `#${TINH_THANH_TAB.PHUONG_XA}`"
        @click="
          changeCurrentTab(
            TINH_THANH_TAB.PHUONG_XA,
            GIA_TRI_TINH_THANH_TAB.PHUONG_XA
          )
        "
        v-if="!(disabledItem && this.$route.params.id === 'tao-moi')"
      >
        <div
          class="box box-form"
          v-if="activeTab === `#${TINH_THANH_TAB.PHUONG_XA}`"
        >
          <DanhSachChung isPhuongXa />
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  ROUTE_NAME,
  BO_QUA_BUTTON_LABEL,
  TINH_THANH_TAB,
  GIA_TRI_TINH_THANH_TAB,
} from "@/constants/constants";
import { mapGetters } from "vuex";
import DanhSachChung from "./DanhSachChung";

export default {
  name: "CapNhatNguoiDung",
  data() {
    return {
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      internalChiTietNguoiDung: {},
      activeTab: "#thong-tin-nhom",
      TINH_THANH_TAB: TINH_THANH_TAB,
      GIA_TRI_TINH_THANH_TAB: GIA_TRI_TINH_THANH_TAB,
      disabledItem: true,
      userCanBoDepartment: null,
      internalAppId: null,
    };
  },
  components: {
    DanhSachChung,
  },
  computed: {
    ...mapGetters({
      chiTietNguoiDung: "user/chiTietNguoiDung",
      danhSachCanBo: "user/danhSachCanBoLayVaoNguoiDung",
      danhSachApp: "app/tatCaApp",
      appId: "common/appId",
    }),
    danhSachCanBoLayVaoNguoiDung() {
      if (!this.danhSachCanBo) {
        return [];
      }
      let danhSach = [];
      danhSach = (this.danhSachCanBo.items || []).map((item) => {
        return {
          id: item.id,
          name: item.userName,
          ...item,
        };
      });
      return danhSach;
    },
    danhSachAppNoiBo() {
      return this.danhSachApp.filter((x) =>
        (this.internalChiTietNguoiDung.applicationIds || []).includes(x.id)
      );
    },
  },
  created() {
    this.activeTab = location.hash;
  },
  watch: {
    chiTietNguoiDung: {
      handler() {
        this.internalChiTietNguoiDung = Object.assign(
          {},
          this.internalChiTietNguoiDung,
          this.chiTietNguoiDung
        );
        if (
          this.internalChiTietNguoiDung.applicationIds &&
          this.internalChiTietNguoiDung.applicationIds.length === 1
        ) {
          this.internalAppId = this.internalChiTietNguoiDung.applicationIds[0];
        }
      },
    },
  },
  methods: {
    changeCurrentTab(currentTab, giaTriCurrentTab) {
      this.activeTab = `#${currentTab}`;
      this.$router
        .push({
          name: ROUTE_NAME.QUAN_LY_DANH_MUC.TINH_THANH.XEM,
          hash: `#${currentTab}`,
          params: { item: `${giaTriCurrentTab}` },
        })
        .catch(() => {});
    },
  },
};
</script>
